<template>
    <v-dialog v-model="dialogEditShow" max-width="700px">
      <v-card class="pa-4 pa-sm-8">
        <v-btn class="button-close ma-4" icon @click="dialogEditShow = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2 class="text-center">Данные менеджера</h2>
        <form @submit.prevent="editManagerConfirm" class="mt-6">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <v-text-field label="Фамилия *"
                    :value="editedItem.last_name"
                    @input="$v.editedItem.last_name.$model = upperFirst($event), onInput('last_name')"
                    :error-messages="lastnameErrors"
                    outlined dense />
              </div>
              <div class="col-md-6">
                <v-text-field label="Имя *"
                    :value="editedItem.first_name"
                    @input="$v.editedItem.first_name.$model = upperFirst($event), onInput('first_name')"
                    :error-messages="firstnameErrors"
                    outlined dense />
              </div>
            </div>

            <div class="row">
              <!-- <div class="col-md-6">
                <v-text-field label="Номер телефона"
                        type="tel"
                        v-model="editedItem.phone"
                        @input="$v.editedItem.phone.$touch()"
                        @blur="$v.editedItem.phone.$touch()"
                        :error-messages="phoneErrors"
                        v-mask="'+7-(###)-###-##-##'"
                        outlined dense />
              </div> -->
              <div class="col-md-6">
                <v-text-field label="Адрес эл. почты *"
                        v-model.trim="editedItem.email"
                        @input="clearError"
                        @blur="$v.editedItem.email.$touch()"
                        :error-messages="emailErrors"
                        outlined dense readonly disabled />
              </div>
            </div>

            <div v-for="(err, ind) in errors.edit" :key="ind" class="error--text">
              <template v-if="!editedItem.hasOwnProperty(err[0])">
                <div v-for="(e, i) in err[1]" :key="i">{{e}}</div>
              </template>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6 mx-auto">
              <v-btn type="submit" class="w-100" color="primary" :loading="loading.edit" :disabled="loading.edit">
                Сохранить
              </v-btn>
            </div>
          </div>
        </form>
      </v-card>
    </v-dialog>
</template>

<script>
/*eslint-disable*/

import { mapActions, mapGetters } from 'vuex';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import { upperFirst } from 'lodash';
import { firstnameValidation, lastnameValidation } from '@/common/validationHelpers';
import { EMAIL, FIRST_NAME, LAST_NAME } from '@/common/constants/validations';
import { MESSAGES } from '@/common/constants/errorMessages';
import { phoneValidation } from '@/common/validationHelpers';
import { VueMaskDirective } from 'v-mask';

export default {
  validations: {
    editedItem: {
      last_name: { required, lastnameValidation, maxLength: maxLength(LAST_NAME.MAX_LENGTH) },
      first_name: { required, firstnameValidation, maxLength: maxLength(FIRST_NAME.MAX_LENGTH) },
      email: { required, email, maxLength: maxLength(EMAIL.MAX_LENGTH) },
      // phone: { phoneValidation },
    },
  },
  directives: {
    mask: VueMaskDirective,
  },
  data: () => ({
    editedItem: {
      id: 0,  
      last_name: '',
      first_name: '',
      // phone: '',
      email: '',
    },
  }),
  watch: {
    dialogEditShow(newVal) {
      if (newVal) {
        this.editedItem = (
          ({ id, last_name, first_name, email, }) =>
          ({ id, last_name, first_name, email, })
          )(this.editedManager );
      }
    },
  },
  computed: {
    ...mapGetters({
      loading: 'users/managers/loading',
      errors: 'users/managers/errors',
      editedManager: 'users/managers/editedManager',
    }),
    dialogEditShow: {
      get() {
        return this.$store.getters['users/managers/dialogEditShow'];
      },
      set(val) {
        if (!val) {
          this.$v.$reset();
        }
        this.setDialogEditShow(val);
      },
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.last_name.$dirty) return errors;
      if (!this.$v.editedItem.last_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.last_name.lastnameValidation) errors.push(MESSAGES.INCORRECT_LASTNAME);
      if (!this.$v.editedItem.last_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(LAST_NAME.MAX_LENGTH));

      return this.errors.edit.find((err) => err[0] === 'last_name')?.[1] ?? errors;
    },
    firstnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.first_name.$dirty) return errors;
      if (!this.$v.editedItem.first_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.first_name.firstnameValidation) errors.push(MESSAGES.INCORRECT_FIRSTNAME);
      if (!this.$v.editedItem.first_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(FIRST_NAME.MAX_LENGTH));

      return this.errors.edit.find((err) => err[0] === 'first_name')?.[1] ?? errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      if (!this.$v.editedItem.email.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.email.email) errors.push(MESSAGES.INCORRECT_EMAIL);
      if (!this.$v.editedItem.email.maxLength) errors.push(MESSAGES.MAX_LENGTH(EMAIL.MAX_LENGTH));

      return this.errors.edit.find((err) => err[0] === 'email')?.[1] ?? errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.phone.$dirty) return errors;
    //   if (!this.$v.editedItem.phone.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.phone.phoneValidation) errors.push(MESSAGES.INCORRECT_PHONE);

      return this.errors.edit.find((err) => err[0] === 'phone')?.[1] ?? errors;
    },

  },
  methods: {
    ...mapActions({
      clearError: 'users/managers/clearError',
      setDialogEditShow: 'users/managers/setDialogEditShow',
      saveManager: 'users/managers/saveManager',
    }),
    onInput() {
      if (this.errors.edit.length) this.clearError();
    },
    editManagerConfirm() {
      if (this.loading.edit) return;
      this.$v.$touch();
      if (this.editedItem && !this.$v.$invalid) {
        const form = {
          ...this.editedItem,
          // phone: this.editedItem.phone.match(/\d+/g).join([]),
        };
        this.saveManager(form).then(() => {
          this.dialogEditShow = false;
        });
      }
    },
    upperFirst,
  },
};

</script>
